import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';

const LEGEND_ITEMS = [
  { key: 'optimal', color: 'bg-green-500' },
  { key: 'good', color: 'bg-blue-500' },
  { key: 'regular', color: 'bg-amber-500' },
  { key: 'low', color: 'bg-red-500' },
] as const;

interface PerformanceLegendProps {
  className?: string;
}

export function PerformanceLegend({ className }: PerformanceLegendProps) {
  const { t } = useTranslation('laborPerformance');

  return (
    <div
      data-testid="labor-performance-legend"
      className={cn('flex flex-wrap justify-center gap-x-4 gap-y-1', className)}
    >
      {LEGEND_ITEMS.map(({ key, color }) => (
        <div key={key} className="flex items-center gap-1.5">
          <span className={cn('h-2.5 w-2.5 rounded-sm flex-shrink-0', color)} />
          <span className="text-xs text-muted-foreground">{t(`legend.${key}`)}</span>
        </div>
      ))}
    </div>
  );
}
